
import { defineComponent, PropType } from 'vue'

// @components
import Loader from '@/common/components/UI/Loader/index.vue'

// @types
import { GlobalSearchT } from '@/core/types/global_search.types'

export default defineComponent({
    components: { Loader },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        failed: {
            type: Boolean,
            default: false,
        },
        errorText: {
            type: String,
            default: 'Произошла ошибка'
        },
        suggestions: {
            type: Array as PropType<GlobalSearchT[]>,
            default: () => []
        }
    },
    emits: ['select'],
    setup(props, { emit }) {
        const emitSelect = (suggestion: GlobalSearchT) => {
            emit('select', { ...suggestion })
        }

        return {
            emitSelect
        }
    }
})
